import { ApiConfig as CONFIG_API, ApiConfig } from "config/config";
import { REST, Models, Args } from 'fluent-forever-shared-types';

/** Current User Subscription Information  */
export const activeSubscriptionInfo = (body: Args.IValidateCouponCodeArg, request) => {
	return request.post(CONFIG_API.url + REST.PATH.ACTIVE_SUBSCRIPTION_INFO, body)
		.then(rst => rst.data)
}

/** User Account Settings Info  */
export const fetchAccountSettingsInfo = (request): Promise<Models.IAccountSettings> => {
	return request.get(CONFIG_API.url + REST.PATH.USER_ACCOUNT_SETTINGS)
		.then(rst => rst.data)
}

/** Fetch user info from API */
export const fetchUserInfo = async (request) => {
	const result = await request.get(ApiConfig.url + REST.PATH.USER_ACCOUNT)
	return result.data as Models.IUserAccount;
}

// Re-send email confirmation email
export const resendEmailConfirmation = async (request) => {
	return request.post(CONFIG_API.url + REST.PATH.RESEND_EMAIL_CONFIRMATION)
		.then(result => result.data)
}




// WEBPACK FOOTER //
// ./src/api/userinfo.ts